import { Component } from '@angular/core';

@Component({
  selector: 'app-bajaj-header',
  templateUrl: './bajaj-header.component.html',
  styleUrls: ['./bajaj-header.component.css']
})
export class BajajHeaderComponent {

}
